module.exports = __webpack_public_path__ + "img/icon02.8093b2f2.png";